import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Notifications } from "./pages";

export const NotificationsRouter = [
  <Route
    path="/notifications"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Notifications />
      </ProtectedRoute>
    }
  />,
];
